var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99167 6.93289C7.66337 5.91482 9.72258 5.07693 12 5.07693C14.2775 5.07693 16.3367 5.91482 18.0084 6.93289C19.6892 7.95651 21.0636 9.21389 21.9871 10.1707L22.0633 10.2495C22.6193 10.8241 23.0769 11.2971 23.0769 12C23.0769 12.7029 22.6193 13.1759 22.0633 13.7505L21.9871 13.8293C21.0636 14.7861 19.6892 16.0435 18.0084 17.0671C16.3367 18.0852 14.2775 18.9231 12 18.9231C9.72258 18.9231 7.66337 18.0852 5.99167 17.0671C4.31084 16.0435 2.93646 14.7861 2.01291 13.8293L1.93674 13.7505C1.38076 13.1759 0.923096 12.7029 0.923096 12C0.923096 11.2971 1.38076 10.8241 1.93674 10.2495L2.01291 10.1707C2.93646 9.21389 4.31084 7.95651 5.99167 6.93289Z",
    fill: "#DAE3F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.97eeac68505732fdb33a8547f71d00bd.svg";
export { ForwardRef as ReactComponent };